<mat-dialog-actions class="dialog-actions">
  <nv-button type="secondary" (clickButton)="onCancel()">
    Cancel
  </nv-button>
  <nv-button htmlType="submit" (clickButton)="onSave($event)" [disabled]="isSaveDisabled">
    Save
  </nv-button>
</mat-dialog-actions>